import "slick-carousel"

$ ->
  # 検索ボックスのクリックカウント[sp]
  $('.js-search-box').on 'submit', ->
    onclickcatalyst_clickcount('search_box', 'event7')

  #地域リストの開閉
  $(document).on 'click', '.js-toggle-list-switch', (e) ->
    $(@).parents('.js-toggle-list').toggleClass('is-active')
    e.stopPropagation()

  #地域リストの開閉(バルーン方式)
  $(document).on 'click', '.js-balloon-list-switch', (e) ->
    list = $(@).parents('.js-toggle-list')
    list.siblings().removeClass('is-active')
    list.toggleClass('is-active')
    e.stopPropagation()
    $(document).on 'click', ->
      $('.js-toggle-list').removeClass('is-active')

  # 汎用プルダウンメニュー
  $('.js-pull-down-parent').hover ->
    $('.js-pull-down-children', @).stop(true, true).slideDown('fast')
  , ->
    $('.js-pull-down-children', @).stop(true, true).slideUp('fast')

  # タブ・コンテンツ
  $('.js-tab-item').on 'click', ->
    tabId = $(@).attr('data-tab')
    $('.js-tab-item').removeClass('is-tab-active')
    $('.js-tab-contents').removeClass('is-tab-active').hide()
    $(@).addClass('is-tab-active')
    $('#' + tabId).addClass('is-tab-active').show()
    # Tripリスト追加ページ
    # 検索ボックスの切り替え
    if $('#js-trip-lists-new').length > 0
      target =  $(@).attr('data-toggle')
      $('#' + target).addClass('is-tab-active').show()

  # 複数タブに対応
  $(document).on 'click', '.js-tab-item--multi', ->
    tabContainer = $(@).parents('.js-tab-container')
    tabItem = tabContainer.find('.js-tab-item--multi')
    tabContents = tabContainer.find('.js-tab-contents')
    activeClass = 'is-tab-active'
    tabItem.removeClass(activeClass)
    $(@).addClass(activeClass)
    tabIindex = tabItem.index(@)
    tabContents.removeClass(activeClass).hide()
    tabContents.eq(tabIindex).addClass(activeClass).show()

  # もっと見るリンク押下
  $('.js-show-more-button').on 'click', (e) ->
    $(@).parent().find('.js-show-more-target').show()
    $(@).hide()

  $('.js-smooth-scroll').on 'click', (e) ->
    if $(@).parents('.js-nav').length > 0
      headerHeight = $('.js-nav').height()
    else
      headerHeight = 0
    href = $(@).attr('href')
    target = $(if href == '#' or href == '' then 'html' else href)
    position = target.offset().top - (headerHeight + 16)
    position = position - ($('.js-header').height() + 8) if $('.js-header').length > 0 && position < window.pageYOffset
    $('html, body').animate { scrollTop: position }, 400, 'swing'
    e.preventDefault()

  modalHash = "#modal";

  $(document).on 'shown.bs.modal', '.c-modal', ->
    modal = $(this)
    history.pushState(null, null, modalHash);
    window.onpopstate = ->
      modal.modal('hide')
      window.onpopstate = ->

  $(document).on 'hidden.bs.modal', '.c-modal', ->
    if window.location.hash
      history.back()

  if window.location.hash == modalHash && history.length > 2
    history.back()

  $(document).on 'click', '.js-click-count', ->
    onclickcatalyst_clickcount($(@).attr('data-click-area'), $(@).attr('data-event'))

  # 指定した範囲を追従させる
  if $('.js-floating').length > 0
    viewport = document.querySelector('.js-floating-viewport')
    floating = document.querySelector('.js-floating[data-floating]')
    floatingBottom = document.querySelector('.js-floating-bottom[data-floating-bottom]')
    options =
      rootMargin : '0% 0% -100% 0%'
    observer = new IntersectionObserver(((entries) ->
      entries.forEach (entry) ->
        if entry.isIntersecting
          floating.classList.add('c-floating--active')
          if floatingBottom
            floatingBottom.classList.add('c-floating--active')
          # TODO: GumGumの広告が自動表示されるため暫定対応
          $('div[data-gg-moat]').fadeOut('fast')
        else
          floating.classList.remove('c-floating--active')
          if floatingBottom
            floatingBottom.classList.remove('c-floating--active')
    ), options)
    observer.observe(viewport)

  if $('.js-floating-ad').length > 0
    viewportAd = document.querySelector('.js-floating-ad-viewport')
    optionsAd =
      rootMargin : '0% 0% -100% 0%'
    observerAd = new IntersectionObserver(((entries) ->
      entries.forEach (entry) ->
        if entry.isIntersecting
          if $('div[data-gg-moat]').length > 0
            $('div[data-gg-moat]').fadeIn()
          else
            googletag.cmd.push(() ->
              googletag.display('div-gpt-ad-icotto_SP/overlay')
            )
        else
          $('div[data-gg-moat]').fadeOut('fast')
    ), options)
    observerAd.observe(viewportAd)

  # ヘッダーメニューのクリップ開閉
  $('.js-dropdown').on 'click', (e) ->
    $(@).next().slideToggle().addClass('is-dropdown-active')
    $(@).css('display', 'flex')
    e.stopPropagation()
    $(document).on 'click', ->
      $('.is-dropdown-active').fadeOut('fast')

  # PWA(iOS)のみメッセージ表示
  if $('.js-pwa-notice').length > 0
    user_agent = window.navigator.userAgent.toLowerCase()
    if (user_agent.indexOf('iphone') > 0 && location.search == '?lid=homescreen')
      $('.js-pwa-notice').html('
        <p class="c-notice__message c-notice__message--link"><a data-toggle="modal" data-target="#target-pwa-notice" href="javascript:void(0);">ブラウザの「戻る」ボタンが表示されない方へ</a></p>
        ')

  # 口コミパーツ
  $('.js-slick-review-image').slick
    dots: true
  $('[id^="target-review-images-"]').on 'shown.bs.modal', (event) ->
    $slickNode = $(event.target).find('.js-slick-review-image')
    $slickNode.slick('setPosition')
    $slickNode.slick('slickGoTo', event.relatedTarget.dataset.index)

  # 追従メニューを途中から表示
  if $('.js-sticky').length > 0
    sticky = document.getElementsByClassName('js-sticky')[0]
    target = document.getElementsByClassName('js-sticky-target')[0]
    observer = new IntersectionObserver (entries) ->
      for entry in entries
        sticky.classList.toggle('c-sticky--active', !entry.isIntersecting)
    observer.observe(target)
